
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M429.3 93.38l-74.63-74.64C342.6 6.742 326.3 0 309.4 0H160c-35.3 0-64 28.65-64 64l.01 288c0 35.34 28.65 64 64 64h224c35.19 0 63.99-28.8 63.99-64V138.6c0-16.9-6.7-33.2-18.7-45.22zM400 352c0 8.836-7.164 16-16 16H160c-8.838 0-16-7.164-16-16V64.13c0-8.836 7.164-16 16-16h128V128c0 17.67 14.33 32 32 32h79.99v192zm-72 160H120C53.83 512 0 458.2 0 392V120c0-13.2 10.75-24 24-24s24 10.8 24 24v272c0 39.7 32.3 72 72 72h208c13.25 0 24 10.75 24 24s-10.7 24-24 24z"}})])
          )
        }
      }
    